module.exports = __webpack_public_path__ + "img/education9.e844c9c5.png";